import { detectIsMobile } from '~/utils/isMobile';
import { defineNuxtRouteMiddleware, useNuxtApp } from '#app';

export default defineNuxtRouteMiddleware((to, from) => {
  // SSR: use req.headers['user-agent'], CSR: use window.navigator.userAgent
  let ua = '';
  if (process.server) {
    // @ts-ignore
    ua = useNuxtApp().ssrContext?.event?.req?.headers['user-agent'] || '';
  } else if (typeof window !== 'undefined') {
    ua = window.navigator.userAgent;
  }
  const isMobile = detectIsMobile(ua);
  useNuxtApp().payload.isMobile = isMobile;
});
